const endpoints = {
  listIdentities: (): string => `identity`,
};

export default endpoints;
